import { render, staticRenderFns } from "./MoviesHome.vue?vue&type=template&id=7bb262d8&scoped=true&"
import script from "./MoviesHome.vue?vue&type=script&lang=js&"
export * from "./MoviesHome.vue?vue&type=script&lang=js&"
import style0 from "./MoviesHome.vue?vue&type=style&index=0&id=7bb262d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb262d8",
  null
  
)

export default component.exports